<template lang="html">
  <div class="sidebar-page">
    <section class="sidebar-layout">
      <b-sidebar
        position="static"
        :mobile="mobile"
        :expand-on-hover="expandOnHover"
        :reduce="reduce"
        :fullheight="fullheight"
        type="is-light"
        open
      >
        <div class="py-3">
          <b-menu class="is-custom-mobile">
            <b-menu-list>
<!--              <b-menu-item-->
<!--                class="py-2"-->
<!--                icon="chart-line"-->
<!--                label="Dashboard"-->
<!--                href="/dashboard"-->
<!--                :active="menuItemIsActive(['dashboard'])"-->
<!--              ></b-menu-item>-->
              <b-menu-item
                class="py-2"
                icon="project-diagram"
                label="Projects"
                href="/projects"
                :active="menuItemIsActive(['projects', 'project_overview', 'test_job_new', 'test_job_edit'])"
              ></b-menu-item>
              <b-menu-item
                class="py-2"
                icon="align-justify"
                label="Test types"
                href="/test-types"
                :active="menuItemIsActive(['test_types', 'test_type_edit', 'test_type_new'])"
              ></b-menu-item>
              <b-menu-item
                class="py-2"
                icon="cogs"
                label=" System"
                :expanded="menuItemIsActive(['system_export', 'system_import'])"
              >
                <b-menu-item
                  class="py-2"
                  icon="download"
                  label="Export"
                  href="/system/export"
                  :active="menuItemIsActive(['system_export'])"
                ></b-menu-item>
                <b-menu-item
                  class="py-2"
                  icon="upload"
                  label="Import"
                  href="/system/import"
                  :active="menuItemIsActive(['system_import'])"
                ></b-menu-item>
              </b-menu-item>

            </b-menu-list>

          </b-menu>
        </div>
      </b-sidebar>
    </section>
  </div>
</template>

<script>

export default {
  name: 'Sidebar',

  data () {
    return {
      isActive: true,
      fullheight: true,
      expandOnHover: false,
      mobile: "reduce",
      reduce: false
    }
  },

  methods: {
    menuItemIsActive (routeNames) {
      return routeNames.indexOf(this.$route.name) !== -1
    }
  }
}
</script>
